import './greetings.scss';

import { load } from 'recaptcha-v3';

import { T18n } from '../utils/t18n';
import { Logger } from '../utils/logger';

import tmplModal from '../../templates/greetings-modal.hbs';
import tmplForm from '../../templates/greetings-form.hbs';
import tmplPreview from '../../templates/greetings-preview.hbs';
import tmplEmailHead from '../../templates/greetings-email-head.hbs';
import tmplEmailBody from '../../templates/greetings-email-body.hbs';
import tmplEmailEnd from '../../templates/greetings-email-end.hbs';

const COMPONENT_NAME = 'greetings';
const BEM = {
  BLOCK: COMPONENT_NAME,
  MODIFIER_DEFAULT_LANGUAGE: 'greetings--default-language',
  ELEMENT_MODULE: 'greetings__module',
  ELEMENT_FORM: 'greetings__form',
  FORM_SELECT_WRAPPER: 'greetings__form__select-wrapper',
  FORM_SELECT_WRAPPER_OPEN: 'greetings__form__select-wrapper--open',
};

/**
 * version    1.0
 * class      <type> (Greetings)
 * classdesc
 */
export class Greetings {
  constructor() {
    this._els = {
      block: $('body').find(`.${BEM.BLOCK}`),
    };

    this._initRecaptcha();
    this._initI18n();
    this._reinitUI();
  }

  // private methods

  _initRecaptcha() {
    const key = window.recaptchaKey;
    if (key) {
      load(key, { autoHideBadge: true }).then((recaptcha) => {
        this._recaptchaKey = key;
        this._recaptcha = recaptcha;
      });
    } else {
      Logger.error('_initRecaptcha could not find the \'recaptchaKey\' global variable. Recaptcha not initialized.');
    }
  }

  _initI18n() {
    T18n.addDictionaryFromMarkup('greetings');
    T18n.setCurrentDictId('greetings');
  }

  _reinitUI() {
    this._initIframeResize();
    this._render();
    const $module = $('body').find(`.${BEM.ELEMENT_MODULE}`);
    this._initSelect($module);
    this._initFileInput($module);
    this._initLanguageSelection($module);
    this._initTextarea($module);
    this._initFormSubmission($module);
  }

  _initIframeResize() {
    window.greetingsResizeIframe = (iframe) => {
      if (iframe && iframe.contentWindow) {
        const h = iframe.contentWindow.document.body.scrollHeight;
        // eslint-disable-next-line no-param-reassign
        iframe.height = `${h}px`;
      }
    };
  }

  _setIframeContent($iframe, emailTemplateHead, emailTemplateBody) {
    $iframe.contents().find('head')
      .html(emailTemplateHead);

    $iframe.contents().find('body')
      .css({
        margin: 0,
        padding: 0,
        fontFamily: 'Arial, Helvetica, sans-serif',
      })
      .html(emailTemplateBody);

    $iframe.contents().find('#greetings-customizable-text')
      .empty();

    const update = () => window.greetingsResizeIframe($iframe[0]);
    setTimeout(update, 1000);
    setTimeout(update, 2000);
    setTimeout(update, 3000);
    $(window).off('resize.greetings-iframe-preview').on('resize.greetings-iframe-preview', update);
  }

  _render() {
    const self = this;
    const form = tmplForm({});
    const preview = tmplPreview({});
    const emailTemplateHead = tmplEmailHead({});
    const emailTemplateBody = tmplEmailBody({
      footImage: T18n.getTranslation('EMAIL_TEMPLATE_FOOT_IMAGE_URL'),
      colorMain: T18n.getTranslation('EMAIL_TEMPLATE_MAIN_BG_COLOR'),
      colorTableMain: T18n.getTranslation('EMAIL_TEMPLATE_MAIN_TABLE_BG_COLOR'),
    });
    const emailTemplateEnd = tmplEmailEnd({});

    this._els.block.empty();

    // render the form

    this._els.block.append(form);

    // update the 'body' hidden field with the email template

    const encodedEmailSource = emailTemplateHead + emailTemplateBody + emailTemplateEnd;
    this._els.block.find('#frm-greetings-body').val(encodedEmailSource);

    // render the email preview

    this._els.block.append(preview);
    const $iframe = this._els.block.find('.greetings__preview__iframe');
    if ($iframe.length > 0) {
      $($iframe[0]).on('load', () => {
        self._setIframeContent($iframe, emailTemplateHead, emailTemplateBody); // Firefox
      });
      self._setIframeContent($iframe, emailTemplateHead, emailTemplateBody); // Other browsers
    }
  }

  _initSelect($module) {
    $module.find(`.${BEM.FORM_SELECT_WRAPPER}`).each(function () {
      const $selectItem = $(this);

      $(this).find('.greetings__form__select-arrow').on('click', () => {
        $selectItem.trigger('click');
      });

      $selectItem.on('click', () => {
        $module.each(() => {
          const elemOpen = $module.find(`.${BEM.FORM_SELECT_WRAPPER_OPEN}`);
          if (elemOpen.length > 0) {
            if (!$selectItem.hasClass('greetings__form__select-wrapper--open')) {
              $selectItem.addClass('greetings__form__select-wrapper--open');
            }
            elemOpen.removeClass('greetings__form__select-wrapper--open');
          } else {
            $selectItem.addClass('greetings__form__select-wrapper--open');
          }
        });
      });
    });
  }

  _initLanguageSelection($module) {
    const self = this;
    const $select = $module.find('#frm-greetings-language');
    $select.on('change', () => {
      const choosenLangId = $select.val();
      Logger.log(`_initLanguageSelection changing language to "${choosenLangId}".`);
      T18n.setCurrentLangId(choosenLangId);
      this._reinitUI();
      $('#frm-greetings-language').val(choosenLangId);

      self._enableForm();
    });
  }

  _initTextarea($module) {
    // Aggiorna la preview quando l'utente cambia il contenuto nella textarea
    const $messageTextarea = $module.find('#frm-greetings-message');
    $messageTextarea.on('keyup blur', () => {
      // Gestione andata a capo
      let finalValue = $messageTextarea.val();
      finalValue = finalValue.replace(/\n/gi, '<br/>');
      const $iframe = this._els.block.find('.greetings__preview__iframe');
      $iframe.contents().find('#greetings-customizable-text').html(finalValue);
      window.greetingsResizeIframe($iframe[0]);
    });
  }

  _enableForm() {
    this._els.block.removeClass(BEM.MODIFIER_DEFAULT_LANGUAGE);
    this._els.block.find('.greetings__form__field').removeClass('greetings__form__field--disabled');
    this._els.block.find('input, select, textarea, .greetings__form__submit .btn').attr('disabled', false);
  }

  _initFileInput($module) {
    $module.each(() => {
      // On input[file] change
      const $inputFile = $module.find('input[type="file"]');
      if ($inputFile.length > 0) {
        $inputFile.on('change', function () {
          const $fileInfo = $('.greetings__file-container__info');
          const _value = $(this).val();
          if (_value !== '') {
            // Prima di visualizzarlo verifico anche l'estensione
            if ($('.greetings__file-container').find('[name="excel"]').hasExtension(['xls', 'xlsx'])) {
              const filename = _value.split(/(\\|\/)/g).pop();
              $fileInfo.css('display', 'inline');
              $fileInfo.find('span').html(filename);

              $fileInfo.find('a').off('click').on('click', (e) => {
                e.preventDefault();
                $fileInfo.hide();
                $fileInfo.find('span').html('');
                $inputFile.val('');
              });
            } else {
              $fileInfo.find('span').html('');
              $inputFile.val('');
              // alert(loc_ExcelExtension);
            }
          } else {
            $fileInfo.hide();
          }
        });
      }
    });
  }

  _initFormSubmission($module) {
    const $form = $module.find(`.${BEM.ELEMENT_FORM}`);
    $form.on('submit', (event) => {
      event.preventDefault();

      // controllo client-side la validazione del form con bootstrap
      if ($form[0].checkValidity() === false) {
        event.stopPropagation();
        $form[0].classList.add('was-validated');
        return;
      }

      $form[0].classList.add('was-validated');

      // Validazione: O Excel o Email amici (almeno 1 dei 2 deve essere compilato)
      let secondValidityCheck = true;
      let secondCheckMsg = '';
      const filePath = $form.find('#greetings-excel').val();

      if (filePath === ''
        && $form.find('#frm-greetings-recipient-email-0').val() === ''
        && $form.find('#frm-greetings-recipient-email-1').val() === ''
        && $form.find('#frm-greetings-recipient-email-2').val() === ''
        && $form.find('#frm-greetings-recipient-email-3').val() === ''
        && $form.find('#frm-greetings-recipient-email-4').val() === ''
      ) {
        secondValidityCheck = false;
        secondCheckMsg = T18n._('ERR_EXCEL_OR_EMAIL');
      } else if (filePath !== '' && !$form.find('#greetings-excel').hasExtension(['xls', 'xlsx'])) {
        secondValidityCheck = false;
        secondCheckMsg = T18n._('ERR_EXCEL_EXTENSION');
      }

      if (!secondValidityCheck) {
        this._showGenericModal(secondCheckMsg, T18n._('MODAL_CLOSE'));
        return;
      }

      this._sendForm($form);
    });

    if ($('.greetings').length > 0) {
      const titleOffsetTop = $('.greetings__module__title').offset().top;
      setTimeout(() => {
        const scrollContentOnLoad = setInterval(() => {
          if ($('html, body').offset().top !== titleOffsetTop) {
            $('html, body').stop().animate({
              scrollTop: titleOffsetTop,
            }, 800);

            clearInterval(scrollContentOnLoad);
          } else {
            clearInterval(scrollContentOnLoad);
          }
        }, 200);
      }, 1300);
    }
  }

  _sendForm($form) {
    if (!this._recaptcha || !this._recaptchaKey) {
      this._showGenericModal(T18n._('ERR_RECAPTCHA_NOT_INITIALIZED'), T18n._('MODAL_CLOSE'));
      Logger.error('_sendForm: recaptcha was not initialized. Form not sent.');
      return;
    }

    this._recaptcha.execute(this._recaptchaKey, { action: `${$form.attr('name')}_submit` }).then((token) => {
      // Nota:
      //  il backend si deve occupare di validare il token del recaptcha
      //  facendo una chiamata a google ed elaborandone il response (success + score)
      //  restituendo qui il risultato sottoforma di "success" booleano.
      // (vedi https://developers.google.com/recaptcha/docs/v3)
      $form.find('#frm-greetings-recaptcha-token').val(token);

      // estraggo i dati dal form salvandoli come json
      const action = window.greetingsFormUrl;
      const method = $form.attr('method');
      let enctype = $form.attr('enctype');
      let data = $form.serialize();
      let processData = true;

      if (enctype && enctype === 'multipart/form-data') {
        data = new FormData($form[0]);
        processData = false;
        enctype = false;
      }

      $.ajax({
        url: action,
        type: method,
        enctype,
        contentType: enctype,
        data,
        processData,
      }).done((res) => {
        if (res.StatusCode === '0') {
          this._showSuccessModal();
        } else {
          this._showFailureModal(data.Msg);
        }
      }).fail((res) => {
        this._showFailureModal();
        Logger.error('_sendForm: form submission failure', res);
      });
    });
  }

  _showGenericModal(message, closeLabel, closeCallback) {
    const modal = tmplModal({});
    const $modal = $(modal);
    $modal.find('#greetingsModalBody').html(message);
    $modal.find('.modal-footer .btn').html(closeLabel);
    $('#greetingsModalBody').remove();
    $('.tcl-page__main-content').after(modal);
    $modal.modal('show');
    if (closeCallback) {
      $modal.on('hide.bs.modal', closeCallback);
    }
  }

  _showSuccessModal() {
    const modalContent = `<h3>${T18n._('FORM_SUCCESS_TITLE')}</h3><br><p>${T18n._('FORM_SUCCESS_DESC')}</p>`;
    this._showGenericModal(modalContent, T18n._('FORM_SUCCESS_CTA'), () => {
      // svuoto solo i campi email e l'eventuale file uploadato
      $('#frm-greetings-recipient-email-0').val('');
      $('#frm-greetings-recipient-email-1').val('');
      $('#frm-greetings-recipient-email-2').val('');
      $('#frm-greetings-recipient-email-3').val('');
      $('#frm-greetings-recipient-email-4').val('');
      $('#greetings-excel').val('').trigger('change');
    });
  }

  _showFailureModal(message) {
    const modalContent = `<h3>${T18n._('FORM_FAILURE_TITLE')}</h3><br><p>${message}</p><p>${T18n._('FORM_FAILURE_DESC')}</p>`;
    this._showGenericModal(modalContent, T18n._('MODAL_CLOSE'));
  }
}
